import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { I18nService } from 'src/app/services/i18n.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'dialog-content-forgot-password',
    templateUrl: 'dialog-content-forgot-password.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogContentForgotPassword implements OnInit {
  forgotForm!: FormGroup;
  loading = false;
  submitted = false;
  success = false;
  error = '';

  private i18n = inject(I18nService);

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    public dialogRef: MatDialogRef<DialogContentForgotPassword>
  ) { }

  ngOnInit() {
    this.forgotForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get f() { return this.forgotForm.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.forgotForm.invalid) {
      return;
    }

    this.loading = true;
    this.error = '';

    this.userService.forgotPassword(this.f.email.value).subscribe(() => {
      this.loading = false;
      this.success = true;
    }, (err) => {
      this.loading = false;
      this.error = err || this.i18n.t('common.errorOccurred');
    });
  }
}
